import {
  Box,
  Container,
  Flex,
  Heading,
  IconButton,
  Img,
  Link,
  ListItem,
  Text,
  UnorderedList,
} from '@chakra-ui/react';
import React from 'react';
import { FaLinkedin } from 'react-icons/fa';

const FundInFocusRockStudCapital: React.FC = () => (
  <>
    {/* members */}
    <Flex
      as="section"
      flexDirection="column"
      overflow="hidden"
      justify="center"
      height={{ xs: '450px', sm: '300px' }}
      minH={{ xs: '450px', sm: '300px' }}
      maxH="450px"
      pos="relative"
    >
      <Img
        pos="absolute"
        objectFit="cover"
        src="/jpg/blogBanner.jpg"
        alt="members-hero"
        height="100%"
        width="100%"
      />
      <Box
        bg="linear-gradient(93.48deg, #00001F 45.8%, #186658 74.6%)"
        pos="absolute"
        height="100%"
        width="100%"
        opacity="0.7"
      />
      <Container
        maxW="container.xl"
        position="relative"
        zIndex="1"
        flexDir="column"
        px={{ xs: '20px', sm: '28px', md: '45px', lg: '60px', xl: 'inherit' }}
      >
        <Heading
          as="h1"
          mb="20px"
          variant="reportCardTitle"
          fontSize={{ xs: '26px', sm: '28px', md: '32px', lg: '38px' }}
          color="white"
          lineHeight={{ xs: '34px', md: '39px', lg: '42px' }}
        >
          Fund In Focus: From Broking Floors to Bharat’s Future: Abhishek
          Agarwal’s Rocksolid VC Playbook
        </Heading>
        <Text
          fontSize={{ xs: '18px', sm: '18px', md: '20px', lg: '22px' }}
          fontWeight="600"
          color="white"
          lineHeight="21px"
        >
          Abhishek Agarwal, Founder & MD,
          <Link
            href="https://www.rockstudcap.com/"
            target="_blank"
            rel="noreferrer"
          >
            Rockstud Capital
          </Link>
        </Text>
      </Container>
    </Flex>
    <Container
      as="section"
      maxW="container.xl"
      pb="80px"
      pt="40px"
      minH="420px"
      display={{ xs: 'flex', md: 'inherit' }}
      flexDirection="column"
    >
      <Box as="main" w="100%" pb="40px">
        <Text variant="blogAnswer">
          Welcome to our ‘Fund in Focus’ series where we profile our member VC
          funds, underscore their investment philosophy, and highlight some of
          their interesting work. In this exclusive chat with Abhishek Agarwal,
          Founder & MD, Rockstud Capital, opined about the firm’s unique
          investment philosophy, governance-led fund structuring, and their
          flagship Yuva Bharat Fund. Abhishek reflects on his journey from
          public markets to early-stage VC, emphasizing disciplined execution,
          founder-first investing, and policy-aligned thematic bets. With deep
          conviction in India’s youth-driven growth story, Rockstud is backing
          high-impact ventures across DefenceTech, consumer brands, AI, and
          green innovation—grounded in fundamentals, shaped by insights, and
          built for Bharat’s future.
        </Text>
      </Box>

      <Img
        src="https://static.levocdn.com/WGLBUT82/Screenshot2025-04-16at14936PM-KQ52QqEoXUX2.png"
        alt="Perl"
        boxSize="300px"
        float={{ xs: 'right', md: 'left' }}
        alignSelf={{ xs: 'center', md: 'flex-start' }}
        mx={{ xs: '0px', md: '0px' }}
        mr={{ xs: '0px', md: '40px', lg: '60px', xl: '70px' }}
        mb="20px"
        objectFit="contain"
      />
      <Box>
        <Flex flexDir={{ xs: 'column', lg: 'row' }} rowGap="16px">
          <Heading
            textAlign={{ xs: 'center', md: 'left' }}
            fontWeight="800"
            color="blue.400"
          >
            Spokesperson: Abhishek Agarwal, Founder & MD,
            <Link
              href="https://www.rockstudcap.com/"
              target="_blank"
              rel="noreferrer"
            >
              Rockstud Capital
            </Link>
          </Heading>
          <Flex
            columnGap={{ xs: '4px', md: '16px' }}
            justifyContent={{ xs: 'center', md: 'flex-start' }}
            transform={{ xs: 'translateX(12px)', md: 'none' }}
          >
            <Box alignSelf="start" mt="5px">
              <Link
                href="https://in.linkedin.com/in/abhishek-agarwal-rockstud"
                target="_blank"
              >
                <IconButton
                  aria-label="linkedin"
                  icon={
                    <FaLinkedin size="28px" color="rgba(100, 100, 140, 0.6)" />
                  }
                  variant="unstyled"
                  cursor="pointer"
                />
              </Link>
            </Box>
          </Flex>
        </Flex>
        <Box
          ml={{ xs: 'auto', md: '345px', lg: '370px' }}
          mr={{ xs: 'auto', md: '0px' }}
          width={{ xs: '160px', md: '80px' }}
          h="2px"
          bgColor="primary.500"
          borderRadius="5px"
          mt={{ xs: '16px', md: '10px' }}
          mb="15px"
        />
        <Box>
          <Heading variant="blogQuestion" pb="20px" pt="16px" pl="-20px">
            1. You’ve had a remarkable journey—from equities and institutional
            research to setting up Rockstud Capital. What key lessons from your
            time in public markets and broking have stayed with you as a venture
            capital investor?
          </Heading>
          <Text variant="blogAnswer" pb="20px">
            My journey across public equities, institutional research, and
            broking deeply shaped my lens as a VC. The discipline of valuation,
            the importance of corporate governance, and the necessity of
            consistent execution are core principles I’ve carried forward. In
            public markets, you’re taught to analyze with a long-term mindset
            but execute with agility. That balance has become central to how we
            assess early-stage companies—combining a macro understanding with
            micro conviction. The cyclical nature of markets also taught me
            patience and timing, two attributes that are extremely valuable when
            building a venture portfolio.
          </Text>
        </Box>

        {/* Question 2 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            2. What does “Rockstud” mean to you personally, and how does that
            philosophy shape the firm’s approach to investing?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              “Rockstud” to me stands for resilience, precision, and edge. It’s
              inspired by the idea of being solid like a rock and sharp like a
              stud—grounded in fundamentals yet bold in execution. That’s the
              lens we apply to both our partnerships and investments. We back
              founders who have a strong core, are unshaken by volatility, and
              have a differentiated approach to solving large problems. Our
              investment philosophy is to be active yet not intrusive, providing
              the right mix of capital, counsel, and connectivity.
            </Text>
          </Box>
        </Box>
        {/* Ques 3 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            3. From a fund operations standpoint, what makes Rockstud’s approach
            to compliance, governance, and fund structuring unique compared to
            other domestic funds?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              We’ve built Rockstud with an institutional DNA from day one. As a
              SEBI-registered fund operating across AIFs and PMS platforms, we
              hold ourselves to the highest standards of compliance. Our fund
              structuring is designed for transparency and investor-first
              alignment—whether it’s fee structures, conflict management, or
              reporting. We've digitized a significant portion of our fund
              administration and reporting infrastructure to enable seamless,
              real-time collaboration across stakeholders—both internal teams
              and external partners—enhancing transparency, efficiency, and
              decision-making at every level. Internally, we operate with a
              strong governance layer—every deal goes through a structured IC
              process with risk mitigation frameworks in place.
            </Text>
          </Box>
        </Box>

        {/* Question 4 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            4. Rockstud Capital’s Yuva Bharat Fund stands out with its
            demographic and thematic focus. Can you walk us through the ‘aha
            moment’ when this idea clicked for you?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              The Yuva Bharat theme wasn’t born overnight—it was the result of
              years of research, observation, and pattern recognition. We
              started by mapping macroeconomic trends with demographic data and
              emerging consumption patterns. What stood out was India’s youth
              bulge—a massive population of young Indians entering the workforce
              who are digitally native, aspirational, and increasingly
              entrepreneurial. We also noticed critical shifts happening in
              parallel: <br /> <br />
              1). <strong>Digital infrastructure</strong> (like UPI, Aadhaar,
              and ONDC) was reaching scale. <br />
              2).<strong>Policy tailwinds</strong> like Atma Nirbhar Bharat, PLI
              schemes, and Green Planet were nudging innovation inward. <br />
              3). <strong>Consumer behavior </strong> was evolving—toward
              health, convenience, design, and identity. <br />
              We realized that this convergence—demographics + digital +
              domestic innovation—was not just a trend. It was a generational
              opportunity. <br /> <br /> That’s when the Yuva Bharat thesis
              clicked. We weren’t just looking at sectors—we were looking at the
              India of the next decade. A country driven by its youth, reshaping
              how it consumes, learns, works, and builds. And we wanted a fund
              that would not only invest in that vision but amplify it.
            </Text>
          </Box>
        </Box>

        {/* Question 5 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            5. With such a wide sectoral lens—from DefenceTech to HealthTech—how
            does the fund evaluate early-stage opportunities without spreading
            too thin?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              We’re thematic, not opportunistic. The Fund is anchored by our
              core investment theme, Yuva Bharat, which aligns with India's
              growth story and covers sectors that will define our nation’s
              future: <br />
              <Box mt="16px">
                <UnorderedList>
                  <ListItem>
                    <Text as="span" variant="blogAnswer">
                      <strong>Industry 4.0:</strong> Accelerating India's
                      self-reliance in manufacturing with cutting-edge
                      technology.
                    </Text>
                  </ListItem>
                  <br />
                  <ListItem>
                    <Text as="span" variant="blogAnswer">
                      <strong>National Security:</strong> Developing indigenous
                      technologies to mitigate emerging security threats.
                    </Text>
                  </ListItem>
                  <br />
                  <ListItem>
                    <Text as="span" variant="blogAnswer">
                      <strong>Rising Aspirations:</strong> Tapping into India’s
                      position as the world’s third-largest consumer market.
                    </Text>
                  </ListItem>
                  <br />
                  <ListItem>
                    <Text as="span" variant="blogAnswer">
                      <strong>Healthy Lifestyle:</strong> Prioritizing
                      investments in health, wellness, and overall well-being.
                    </Text>
                  </ListItem>
                  <br />
                  <ListItem>
                    <Text as="span" variant="blogAnswer">
                      <strong>Green Planet:</strong>Supporting ventures aimed at
                      achieving net-zero and energy transformation goals.
                    </Text>
                  </ListItem>
                  <br />
                </UnorderedList>
                Each theme is backed by deep research and a filter-first
                approach. We maintain an internal readiness matrix—where we stay
                prepared for specific sectors and only engage when the timing,
                team, and tech align. It’s less about chasing every deal and
                more about being conviction-led. Our IC process ensures depth
                without dilution.
              </Box>
            </Text>
          </Box>
        </Box>

        {/* Question 6 */}
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            6. The Fund leans into emerging government initiatives like Atma
            Nirbhar Bharat and PLI. How critical is policy alignment in your
            investment decisions?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Policy acts as a catalytic layer in our investment decisions. Atma
              Nirbhar Bharat, PLI, and other reforms aren’t just slogans—they
              are massive capital and structural allocators. For early-stage
              companies, being in sync with policy gives them a tailwind in
              scaling and even securing funding or contracts. We track policy
              moves closely and integrate them into our thematic research.
              However, we invest where fundamentals make sense—policy alignment
              is a bonus, not a substitute
            </Text>
          </Box>
        </Box>
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            7. What are some standout portfolio companies that best represent
            the Yuva Bharat thesis? What made them compelling to you?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Several of our portfolio companies bring the Yuva Bharat thesis to
              life in powerful ways.. For instance, Palette Brands—they’re
              redefining what modern Indian consumers expect from home and
              lifestyle products. . With a digital-first distribution model and
              a sharp eye for functional design, they’ve tapped into the
              aspirations of a young, urban demographic that values both
              aesthetics and utility. Then there’s Expertia AI, which sits right
              at the intersection of India’s talent economy and the future of
              work. Their proprietary AI engine is addressing a deep-rooted
              inefficiency in hiring, enabling faster, smarter talent
              discovery—especially in mid-market and fast-growing businesses.
            </Text>
          </Box>
        </Box>
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            8. You recently led rounds in companies like Expertia AI and Palette
            Brands. What were the key signals that convinced you of their
            potential?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              In Expertia AI, we saw a team with strong tech depth building a
              platform that could disrupt legacy hiring models. Their agentic
              platform had real IP, fast onboarding, and scalable distribution.
              For Palette, it was the clarity in brand vision and the ability to
              create distinct verticals—like Ember Cookware or Totem
              Accessories—each with a scalable identity and margins. In both
              cases, it was founder clarity, velocity of execution, and market
              timing that sealed the deal.
            </Text>
          </Box>
        </Box>
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            9. As India enters its “techade”, what white spaces do you see that
            are still undercapitalized or underexplored by VC investors?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Several. DefenceTech and dual-use technologies still lack
              early-stage capital despite a growing strategic need. Similarly,
              sectors like climate infra, agri-supply chains, and vernacular
              ed-tech need more patient capital and focused expertise. MSME
              digitization, especially in non-metro Tier 2/3 India, is another
              white space. We also believe in the rise of cross-border SaaS from
              India—especially tools that leverage AI for productivity and
              compliance use cases. These are areas where Rockstud is keenly
              looking to deploy.
            </Text>
          </Box>
        </Box>
        <Box pt="20px">
          <Heading variant="blogQuestion" pb="20px" pt="30px">
            10. What advice would you give to first-time fund managers or
            emerging GPs in India today?
          </Heading>
          <Box>
            <Text variant="blogAnswer" pb="16px">
              Build your fund like a startup. Nail your differentiation, stay
              lean, and build trust with LPs. Execution matters more than
              intent. Have an investor-first mindset—transparency, reporting,
              and communication should be world-class. Stay patient and don’t
              chase trends. Instead, develop your circle of competence, own it,
              and build a community around it. And most importantly, never
              compromise on founder quality—it’s the single most predictive
              factor for long-term returns.
            </Text>
          </Box>
        </Box>
      </Box>
      <Heading
        variant="blogQuestion"
        lineHeight="30px"
        pt="16px"
        fontStyle="italic"
        p="12px 12px 0px"
      >
        The content in this section is curated by Team IVCA. For any feedback,
        connect with&nbsp;
        <Link
          href="mailto:paromita.sinha@ivca.in"
          target="_blank"
          style={{ color: 'blue', textDecoration: 'underline' }}
        >
          paromita.sinha@ivca.in
        </Link>
      </Heading>
    </Container>
  </>
);

export default FundInFocusRockStudCapital;
